import { useState } from "react";
import { Space, Table, Tag, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";

import { auditLogsApi, type AuditLog } from "../api/resources";

const ACTION_COLOR: Record<string, string> = {
  create: "green",
  update: "blue",
  delete: "red",
  login: "geekblue",
  "failed-login": "volcano",
};

function formatJson(raw: string | null): string {
  if (!raw) return "(none)";
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

export function AuditLogsPage() {
  const [page, setPage] = useState(1);

  const list = useQuery({
    queryKey: ["audit-logs", page],
    queryFn: () => auditLogsApi.list({ page, pageSize: 30 }),
  });

  return (
    <div>
      <Space style={{ marginBottom: 16, justifyContent: "space-between", width: "100%" }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          审计日志
        </Typography.Title>
        <Typography.Text type="secondary">
          仅记录写操作。GET 请求不入库。
        </Typography.Text>
      </Space>

      <Table<AuditLog>
        rowKey="id"
        loading={list.isLoading}
        dataSource={list.data?.items ?? []}
        pagination={{
          current: page,
          pageSize: 30,
          total: list.data?.total ?? 0,
          onChange: (p) => setPage(p),
          showSizeChanger: false,
        }}
        expandable={{
          expandedRowRender: (row) => (
            <div style={{ display: "flex", gap: 16 }}>
              <div style={{ flex: 1 }}>
                <Typography.Text strong>before</Typography.Text>
                <pre
                  style={{
                    background: "#fafafa",
                    padding: 8,
                    borderRadius: 4,
                    margin: "6px 0 0",
                    maxHeight: 300,
                    overflow: "auto",
                  }}
                >
                  {formatJson(row.beforeJson)}
                </pre>
              </div>
              <div style={{ flex: 1 }}>
                <Typography.Text strong>after</Typography.Text>
                <pre
                  style={{
                    background: "#fafafa",
                    padding: 8,
                    borderRadius: 4,
                    margin: "6px 0 0",
                    maxHeight: 300,
                    overflow: "auto",
                  }}
                >
                  {formatJson(row.afterJson)}
                </pre>
              </div>
            </div>
          ),
        }}
        columns={[
          {
            title: "时间",
            dataIndex: "createdAt",
            width: 160,
            render: (v) => dayjs(v).format("MM-DD HH:mm:ss"),
          },
          { title: "操作人", dataIndex: "adminUsername", width: 140 },
          {
            title: "动作",
            dataIndex: "action",
            width: 110,
            render: (v: string) => (
              <Tag color={ACTION_COLOR[v] ?? "default"}>{v}</Tag>
            ),
          },
          { title: "对象类型", dataIndex: "entityType", width: 200 },
          { title: "对象 ID", dataIndex: "entityId", width: 200, ellipsis: true },
          { title: "IP", dataIndex: "ip", width: 140 },
          { title: "User-Agent", dataIndex: "userAgent", ellipsis: true },
        ]}
      />
    </div>
  );
}
